import React, { useEffect } from 'react';
import styles from './SessionHistory.module.scss';
import SettingsFormLayout, { SettingsBlock } from 'new/components/settings/settingsFormLayout';
import { Box } from 'new/elements/Box';
import { Table } from 'new/elements/Table';
import { columns } from 'new/components/settings/SecurityNPrivacy/components/SessionHistory/columns';
import { useDispatch } from 'react-redux';
import { getSessionHistory } from 'js/actions';
import { useCurrentUser } from 'new/hooks/adapters/useCurrentUser';
import useSessionHistory from 'new/hooks/adapters/useSessionHistory';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import { SESSION_HISTORY_REQUEST } from 'js/constants/actionTypes';

interface SessionHistoryProps {}

export function SessionHistory(props: SessionHistoryProps) {
  const dispatch = useDispatch();
  const history = useSessionHistory();
  const loading = useIsLoading(SESSION_HISTORY_REQUEST);
  const user = useCurrentUser();
  useEffect(() => {
    dispatch(getSessionHistory(user.id));
  }, [user.id]);

  return (
    <SettingsFormLayout>
      <SettingsBlock
        label="Session history"
        description="Protect your account by detecting unauthorized access."
      >
        <Box className={styles.table}>
          <Table loading={loading} height={500} columns={columns} rows={history} />
        </Box>
      </SettingsBlock>
    </SettingsFormLayout>
  );
}
